import Money from '@/common/models/money'
import { ORDER_FORM_COPY } from '@/locales/en'
import { FC } from 'react'
import { SecuritySummaryItem } from './SecuritySummaryItem'
import useBundleTrade from './useBundleTrade'
import { OrderRewardItem } from '@/trading/orderRewardItem'
import { Gift } from 'lucide-react'

export const ReviewItem: FC<{ label: string; value: string }> = ({ label, value }) => {
    return (
        <li className="self-stretch py-4 border-b border-gray-200 inline-flex justify-between items-center">
            <div className="justify-start text-black text-sm font-normal font-['Inter'] leading-5">{label}</div>
            <strong className="justify-start text-black text-base font-['Inter'] leading-6">{value}</strong>
        </li>
    )
}

export const ReviewItems: FC = () => {
    const { orderItems, totals, orderType, name, promotions } = useBundleTrade()
    const activeOrderItems = orderItems.filter((s) => s.units > 0)

    return (
        <ul className="self-stretch flex flex-col justify-start items-start">
            <ReviewItem label={ORDER_FORM_COPY.bundle} value={name ?? ''} />
            <ReviewItem
                label={ORDER_FORM_COPY.securities}
                value={activeOrderItems.map((s) => s.securityCode).join(', ')}
            />
            <ReviewItem
                label={ORDER_FORM_COPY.orderType}
                value={ORDER_FORM_COPY.orderTypeMapping[orderType as keyof typeof ORDER_FORM_COPY.orderTypeMapping]}
            />

            <li className="self-stretch py-4 border-b border-gray-200 flex flex-col justify-start items-start gap-2">
                <div className="text-center justify-start text-black text-sm font-normal font-['Inter'] leading-5">
                    Shares
                </div>
                <div className="self-stretch flex flex-col justify-start items-start gap-4">
                    {activeOrderItems.map((s) => (
                        <div
                            key={s.securityCode}
                            className="self-stretch p-2 bg-stone-50 rounded-lg inline-flex justify-between items-start overflow-hidden"
                        >
                            <SecuritySummaryItem
                                securityCode={s.securityCode}
                                weight={s.weight}
                                amount={s.amount}
                                units={s.units}
                                relevantPrice={s.relevantPrice}
                            />
                        </div>
                    ))}
                </div>
            </li>
            <ReviewItem label={ORDER_FORM_COPY.estimatedAmount} value={Money.of(totals.totalAmount).toString()} />

            <li
                className={`self-stretch py-4 inline-flex justify-between items-center ${!promotions || promotions.length === 0 ? 'border-b border-gray-200' : 'pb-0'}`}
            >
                <div className="justify-start text-black text-sm font-normal font-['Inter'] leading-5">
                    {ORDER_FORM_COPY.estimateBrokerage}
                </div>
                <strong className="justify-start text-black text-base font-['Inter'] leading-6">
                    {Money.of(totals.brokerage).toString()}
                </strong>
            </li>
            {promotions && promotions.length > 0 && (
                <li className="self-stretch py-4 border-b border-gray-200 inline-flex justify-between items-center">
                    <OrderRewardItem
                        icon={<Gift size={20} />}
                        title={ORDER_FORM_COPY.freeTradeItem.title}
                        description={ORDER_FORM_COPY.freeTradeItem.description}
                    />
                </li>
            )}
            <ReviewItem label={ORDER_FORM_COPY.total} value={Money.of(totals.total).toString()} />
        </ul>
    )
}
